import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect, useState } from 'react';
const ThemeContext = createContext(undefined);
export const ThemeProvider = React.memo(({ children }) => {
    const [theme, setThemeState] = useState(localStorage.getItem('theme') || 'light');
    const [isDark, setIsDark] = useState(false);
    // Load theme from localStorage and apply on mount
    useEffect(() => {
        const storedTheme = localStorage.getItem('theme');
        const themeToUse = storedTheme || 'light';
        setThemeState(themeToUse);
        // Apply theme immediately
        let effectiveTheme = themeToUse;
        if (themeToUse === 'system') {
            effectiveTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        }
        const isDarkTheme = effectiveTheme === 'dark';
        setIsDark(isDarkTheme);
        if (isDarkTheme) {
            document.documentElement.classList.add('dark');
        }
        else {
            document.documentElement.classList.remove('dark');
        }
    }, []);
    // Apply theme to document when it changes
    useEffect(() => {
        let effectiveTheme = theme;
        if (theme === 'system') {
            effectiveTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        }
        const isDarkTheme = effectiveTheme === 'dark';
        setIsDark(isDarkTheme);
        if (isDarkTheme) {
            document.documentElement.classList.add('dark');
        }
        else {
            document.documentElement.classList.remove('dark');
        }
        localStorage.setItem('theme', theme);
    }, [theme]);
    const setTheme = (newTheme) => {
        setThemeState(newTheme);
    };
    return (_jsx(ThemeContext.Provider, { value: { theme, setTheme, isDark }, children: children }));
});
export function useTheme() {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}
